import type { IconSvgObject } from './types';

const ReduceParagraphIcon: IconSvgObject = [
  ["path", { d: "M12 12H22M12 8H22M12 16H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 3.5L5.00002 9.50002M2 7L5 10L8 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4.99995 14.5V20.5M2 17L5 14L8 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ReduceParagraphIcon;
